import React from 'react';
import { Col, Form, Row, Tab, Tabs } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { MockServiceGroup } from '../../../../store/mockServiceGroups/mockServiceGroupTypes';
import { useTranslation } from 'react-i18next';
import TagSelector from '../../../../components/selectors/TagSelector';
import { dateAndAuthorFormat } from '../../../../utils/dateUtil';
import GroupedMockServicesTable from './GroupedMockServicesTable';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import {
  reconfigureMockServiceGroup,
  updateMockServiceGroupPatch,
} from '../../../../store/mockServiceGroups/mockServiceGroupsActions';
import GroupParameters from './parameters/GroupParameters';

interface GroupDetailProps {
  group: MockServiceGroup;
  disabled: boolean;
}

const GroupDetail = (props: GroupDetailProps) => {
  const { t } = useTranslation('groups');
  const { group } = props;
  const dispatch = useDispatch();

  const description = (
    <>
      <Form.Label htmlFor={'groupDescription-' + group.id}>{t('groups.description')}</Form.Label>
      <Form.Control
        id={'groupDescription'}
        name="description"
        autoComplete="off"
        placeholder={'Please enter a description...'}
        value={group.description}
        onChange={(event: any) => {
          const group = _.cloneDeep(props.group);
          group.description = event.target.value;
          dispatch(updateMockServiceGroupPatch(group, ['description']));
        }}
        readOnly={props.disabled}
      />
    </>
  );

  const tagSelector = (
    <>
      <Form.Label htmlFor={'tagChooser-' + group.id}>{t('groups.tags')}</Form.Label>
      <TagSelector
        isReadOnly={props.disabled}
        preSelected={group.tags}
        selectHandler={tags => {
          const group = _.cloneDeep(props.group);
          group.tags = tags.map(item => item.name);
          dispatch(updateMockServiceGroupPatch(group, ['tags']));
        }}
      />
    </>
  );

  const created = dateAndAuthorFormat(group.created, group.createdBy);
  const updated = dateAndAuthorFormat(group.updated, group.updatedBy);

  const getInfoRow = () => {
    return (
      <Row key={props.group.id} className={'mb-5'}>
        <Col md={3}>{description}</Col>
        <Col md={3}>{tagSelector}</Col>
        <Col md={2}>
          <Form.Label htmlFor={'created-' + group.id}>{t('groups.created')}</Form.Label>
          <div className="text-truncate" title={created}>
            {created}
          </div>
        </Col>
        <Col md={2}>
          <Form.Label htmlFor={'updated-' + group.id}>{t('groups.updated')}</Form.Label>
          <div className="text-truncate" title={updated}>
            {updated}
          </div>
        </Col>
        <Col md={1}>
          <Form.Label htmlFor={'version-' + group.id}>{t('groups.version')}</Form.Label>
          <div className="text-truncate">{group.version ? group.version : '-'}</div>
        </Col>
        <Col md={1} className={'text-right'}>
          <Button
            disabled={group.status !== 'RUNNING'}
            className={'mt-4'}
            onClick={() => {
              dispatch(reconfigureMockServiceGroup(group));
            }}
          >
            Update
          </Button>
        </Col>
      </Row>
    );
  };

  return (
    <div className={'p-5'}>
      {getInfoRow()}

      <Tabs className={'mb-0'}>
        <Tab eventKey="mockServices" title="Virtual Services" mountOnEnter={true} unmountOnExit={false}>
          <GroupedMockServicesTable group={props.group} disabled={props.disabled} />
        </Tab>
        <Tab eventKey="reporting" title="Parameters" mountOnEnter={true} unmountOnExit={false}>
          <GroupParameters
            group={props.group}
            disabled={props.disabled}
            onChange={group => {
              dispatch(updateMockServiceGroupPatch(group, ['assets'], true));
            }}
          />
        </Tab>
      </Tabs>
    </div>
  );
};

export default GroupDetail;
